import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './i18n';
import i18n, { DEFAULT_LANGUAGE } from '@/i18n';

document.documentElement.lang = i18n.language || DEFAULT_LANGUAGE;
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng || DEFAULT_LANGUAGE;
});

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>
);
